import React from 'react';
import clsx from 'clsx';

import { CopyButton } from '@dashboard/components/OrderPage';

/** A coupon code drawn like a coupon: a dashed outline around the monospace code. */
export default function CouponCode({ code, size = 'sm', copy = false }) {
  return (
    <span className="group inline-flex items-center gap-1.5 align-middle">
      <span
        className={clsx(
          'inline-flex items-center rounded-md border border-dashed border-gray-300 dark:border-border font-mono font-medium tracking-wide text-gray-900 dark:text-foreground',
          size === 'lg' ? 'px-2.5 py-0.5 text-base' : 'px-2 py-0.5 text-xs',
        )}
      >
        {code}
      </span>
      {copy ? <CopyButton text={code} /> : null}
    </span>
  );
}
